import { render } from "./index.vue?vue&type=template&id=f71e9a64&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=f71e9a64&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f71e9a64"

export default script